export default __webpack_public_path__ + "static/media/shipping-delivered.4267c01a.jpg";